module.exports = "<re-captcha\n  #captchaRef\n  [siteKey]=\"settings.siteKey\"\n  size=\"invisible\"\n  (resolved)=\"resolved($event)\">\n</re-captcha>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/captcha/components/recaptcha.component.html
// module id = ./src/app/captcha/components/recaptcha.component.html
// module chunks = main